import OSS from 'ali-oss'
import { Message } from 'element-ui'
import dayjs from 'dayjs'
import { fetchOssToken } from '../api/upload'

export async function uploadFile() {
  try {
    const { data } = await fetchOssToken()

    const client = new OSS({
      region: 'oss-cn-beijing',
      secure: true,
      accessKeyId: data.up_token.AccessKeyId,
      accessKeySecret: data.up_token.AccessKeySecret,
      stsToken: data.up_token.SecurityToken,
      bucket: 'jieyao-pic',
    })
    return callback && callback(client, file)
  } catch (error) {
    console.log(error)
    Message.error('上传失败')
  }
}

export function getUploadName(file) {
  const d = new Date()
  return `${dayjs(d).format('YYYYMMDD')}${Date.now()}.${file.name
    .split('.')
    .pop()}`
}


// WEBPACK FOOTER //
// ./src/utils/upload.js